@let activeTopNavigationValue = activeTopNavigation();

<nav class="left-navigation" [attr.aria-label]="'navigation.left-navigation-title.' + activeTopNavigationValue | translate">
  @if (!isMenuCollapsed()) {
    <div class="left-navigation__group">{{ 'navigation.left-navigation-title.' + activeTopNavigationValue | translate }}</div>
  }

  @if (leftNavigation[activeTopNavigationValue]; as navigationItems) {
    @for (navigationItem of navigationItems; track navigationItem.id) {
      @switch (navigationItem.type) {
        @case (LeftNavigationItemType.Expandable) {
          @let expandableItem = asLeftNavigationExpandableItem(navigationItem);

          @if (!expandableItem.guard || expandableItem.guard()) {
            <itc-left-navigation-expandable-item
              [navigationItem]="expandableItem"
              [isMenuCollapsed]="isMenuCollapsed()"
              [topNavigation]="activeTopNavigationValue"
              [isMobileView]="isMobileView()"
              (navigationItemClick)="navigationItemClick.emit()"
            />
          }
        }
        @default {
          <itc-left-navigation-item
            [navigationItem]="navigationItem"
            [isTooltipEnabled]="isMenuCollapsed()"
            [topNavigation]="activeTopNavigationValue"
            (navigationItemClick)="navigationItemClick.emit()"
          />
        }
      }
    }
  }
</nav>
